export default __webpack_public_path__ + "static/media/domains-are-nfts-mobile.a2b20aa4.svg";